<template>
  <v-snackbar
    v-model="show"
    :color="color"
    bottom
    left>{{ text }}
    <v-btn
      dark
      flat
      @click="show = false"
    >
      Schliessen
    </v-btn>
  </v-snackbar>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'TheSnackbar',
  methods: {
    ...mapActions({
      setShow: 'snackbar/setShow',
    }),
  },
  computed: {
    ...mapGetters({
      getShow: 'snackbar/getShow',
      text: 'snackbar/getText',
      color: 'snackbar/getColor',
    }),
    show: {
      get() { return this.getShow; },
      set(value) { this.setShow(value); },
    },
  },
};
</script>
